import * as z from "zod/v4";
export const ServiceType = z.enum([
    "COMMODITY_TRANSACTION",
    "INSURANCE",
    "MARKETPLACE",
]);
export const PayoutProvider = z
    .enum(["DECENTRO", "RAZORPAY", "CASHFREE"])
    .default("CASHFREE");
export const BankAccountValidationProvider = z
    .enum(["CASHFREE", "DECENTRO"])
    .default("CASHFREE");
export const ApprovalStatus = z.enum([
    "PENDING",
    "APPROVED",
    "REJECTED",
    "ON_HOLD",
]);
export const QualityCheckStatus = z.enum([
    "PENDING",
    "SKIPPED",
    "PASS",
    "FAIL",
]);
export const ListingStatus = z.enum(["PENDING", "LISTED", "DELISTED"]);
export const TransactionStatus = z.enum([
    "PENDING",
    "IN_PROGRESS",
    "COMPLETED",
    "FAILED",
    "ABORTED",
    "REFUNDED",
]);
export const TransitStatus = z.enum([
    "PENDING",
    "SCHEDULED",
    "IN_TRANSIT",
    "COMPLETED",
    "ABORTED",
]);
export const KycDocType = z.enum(["AADHAAR", "PAN", "GSTIN"]);
export const Severity = z.enum(["LOW", "MEDIUM", "HIGH", "CRITICAL"]);
export const AlertCode = z.enum([
    "PROCUREMENT_FULFILLED",
    "SHIPMENT_DELIVERED",
    "MARKET_INSIGHT_DEADLINE_APPROACHING",
    "PRODUCE_BATCH_SUBMITTED",
    "BUYER_ORDER_SUBMITTED",
    "CHANNEL_PARTNER_REGISTERED",
    "XOXODAY_WALLET_LOW_BALANCE",
]);
export const OTPType = z.enum([
    "LOGIN",
    "COLLECTION",
    "SHIPMENT",
    "UPDATE_CREDENTIAL",
    "CASH_COLLECTION",
    "SHIPMENT_DELIVERY",
    "ORDER_CORRECTION",
    "DOCUMENT_APPROVAL",
    "MKT_ORDER_COLLECTION",
    "MKT_SUPERUSER_ORDER_CREATION",
    "SUPER_USER_ACCESS",
    "EQP_MANAGED_BOOKING_CREATION",
]);
export const OTPModeOfDispatch = z.enum(["SMS", "WHATSAPP", "EMAIL", "PUSH"]);
export const SuperPower = z.enum([
    "BYPASS_OTP",
    "BYPASS_KYC",
    "BYPASS_TOKEN_EXPIRATION",
    "BYPASS_ORDER_NOTIFICATION",
]);
export const AccessCodeScope = z.enum([
    "PO_QUALITY_CHECK",
    "SHIPMENT_QUALITY_CHECK",
]);
export const QARuleType = z.enum(["SINGLE", "RANGE"]);
export const NotificationType = z.enum([
    "SELLER",
    "BUYER",
    "CHANNEL_PARTNER",
    "QUALITY_CHECKER",
    "EQUIPMENT_OPERATOR",
]);
export const AddressIntent = z.enum(["CONTACT", "DELIVERY"]);
export const TargetStatus = z.enum([
    "PENDING",
    "IN_PROGRESS",
    "COMPLETED",
    "ABORTED",
    "EXPIRED",
]);
export const AssignmentType = z.enum(["CP", "SUPPLIER"]);
export const WeightUnit = z.enum(["KILOGRAM", "QUINTAL", "TON"]);
export const CountUnit = z.enum(["ITEM", "DOZEN"]);
export const BatchSizes = {
    ITEM: 1,
    DOZEN: 12,
};
export const SettlementUnit = z.enum(["KG", "DOZEN", "ITEM"]);
export const WeightMultiplier = {
    KILOGRAM: 1,
    QUINTAL: 100,
    TON: 1000,
};
export const Grade = z.enum(["HIGH", "MEDIUM", "LOW", "MIXED"]);
export const Quality = z.enum(["NORMAL", "PESTICIDE_FREE", "ORGANIC"]);
export const DurationUnit = z.enum(["DAYS", "WEEKS", "MONTHS"]);
export const BusinessLineType = z.enum([
    "INPUT",
    "OUTPUT",
    "FARMING_SERVICE",
    "FINANCIAL_SERVICE",
]);
export const ProduceTransactionType = z.enum([
    "PURCHASE_ORDER_SUBMISSION",
    "PRODUCE_BATCH_SUBMISSION",
]);
export const PBDelistingReason = z.enum([
    "BID_ACCEPTED",
    "BATCH_WITHDRAWN",
    "EXPIRED",
    "ABORTED",
]);
export const PBAbortedReason = z.enum([
    "WRONG_QUANTITY",
    "MISMATCHED_PRODUCE",
    "WRONG_PRODUCE_DETAILS",
    "WRONG_PROPOSED_RATE",
    "WRONG_PAYMENT_METHOD",
    "PARAMETERS_UPDATED",
    "FARMER_UNREACHABLE",
    "QUALITY_UNACCEPTABLE",
    "FARMER_UNINTERESTED",
    "LOGISTICALLY_INFEASIBLE",
    "RATE_NOT_AGREED",
]);
export const PODelistingReason = z.enum([
    "ACCEPTED",
    "WITHDRAWN",
    "EXPIRED",
    "ABORTED",
]);
export const SettlementStatus = z.enum([
    "PENDING",
    "PARTIALLY_SETTLED",
    "FULLY_SETTLED",
    "REVERTED",
]);
export const PBStatus = z.enum([
    "PENDING",
    "SCANNING",
    "OFFER",
    "SHIP",
    "DELIVERED",
    "COMPLETE",
    "EXPIRED",
    "ABORTED",
]);
export const BOStatus = z.enum([
    "SCANNING",
    "OFFER", // DEFUNCT but retained for backward compat
    "PROCURE",
    "SHIP",
    "DELIVERED",
    "COMPLETE",
    "EXPIRED",
    "ABORTED",
]);
export const UserStatus = z.enum([
    "SELLER",
    "BUYER",
    "CHANNEL_PARTNER",
    "ADMIN",
]);
export const UserInternalRoles = z.enum(["ADMIN"]);
export const InvoiceLICode = z.enum([
    "GOODS_PRIMARY",
    "GOODS_PRIMARY_COMMISSION",
    "PLATFORM_CHARGE",
    "TRANSPORTATION_CHARGE",
    "CUSTOM",
]);
export const PBRejectionCode = z.enum([
    "QUANTITY_MISMATCH",
    "QUALITY_MISMATCH",
]);
export const InvoiceType = z.enum([
    "BUYER_ORDER",
    "PRODUCE_BATCH",
    "GRN",
    "PURCHASE_INVOICE",
    "COLLECTION_TARGET",
    "CP_PAYOUT",
    "SHIPMENT",
    "DEBIT_NOTE",
    "CREDIT_NOTE",
]);
export const InvoiceStep = z.enum(["OFFER", "INGRESS", "EGRESS", "FINAL"]);
export const TransferType = z.enum([
    "NEFT",
    "IMPS",
    "RTGS",
    "UPI",
    "CASH",
    "CHEQUE",
    "CREDIT_NOTE",
    "BUYER_TDS_DEDUCTION",
    "ZOHO",
]);
export const AcceptanceReasonCode = z.enum([
    "PRICE_UNACCEPTABLE",
    "INTEREST_EXPIRED",
    "TRANSPORT_UNAVAILABILITY",
]);
export const PaymentProvider = z.enum(["OFFLINE", "DECENTRO"]);
export const APIKeyType = z.enum(["EMP_LOCATION_TRACKING"]);
export const ReimbursementRequestStatus = z.enum([
    "PENDING",
    "APPROVED",
    "REJECTED",
    "COMPLETED",
]);
export const ActivitySubscriptionType = z.enum([
    "NEW_SELLER_ORDER",
    "NEW_BUYER_ORDER",
    "DAILY_PO_EXPORT",
    "NEW_PROCUREMENT_ORDER",
    "NEW_BO_SETTLEMENT",
    "NEW_INVOICE",
    "NEW_REWARD_CLAIM",
    "ZOHO_SYNC_ERROR",
    "NEW_INSURANCE_APPLICATION",
    "NEW_INSURANCE_CLAIM",
    "ACCOUNT_VALIDATION",
    "REIMBURSEMENT_REQUEST",
    "DOCUMENT_APPROVAL",
    "REVIEW_FEED_ITEMS",
    "UNMATCHED_SOIL_TEST_REPORT",
    "SOIL_TESTING_BOOKING_REQUESTED",
    "RESOURCE_ACCESS_REQUESTED",
    "XOXODAY_WALLET_LOW_BALANCE",
    "CUSTOMER_SUPPORT_REQUEST",
]);
export const Perishability = z.enum([
    "PERISHABLE",
    "SEMI_PERISHABLE",
    "NON_PERISHABLE",
]);
export const BeneficiaryPurposeType = z.enum(["PO_COMMISSION", "PO_AMOUNT"]);
export const BeneficiaryValidationStatus = z.enum([
    "PENDING",
    "VALID",
    "INVALID",
]);
export const BeneficiaryValidatedThrough = z.enum([
    "MANUAL",
    "DECENTRO",
    "CASHFREE",
]);
export const CPCommissionType = z.enum(["PER_ORDER", "PER_MONTH"]);
export const AppType = z.enum([
    "CP_APP",
    "BUYER_APP",
    "SELLER_APP",
    // Deprecated
    "AG_APP",
]);
export const OrderType = z.enum([
    "BUYER_ORDER",
    "PRODUCE_BATCH",
    "COLLECTION_TARGET",
]);
export const UserCohortType = z.enum([
    "BUYER_ORG_TYPE",
    "BUYER_CREDIT_WORTHINESS",
    "CP_ROLE",
]);
export const AppInstallSourceType = z.enum([
    "SOCIAL_MEDIA",
    "PLAY_STORE",
    "RECOMMENDATION",
    "AGRIGATE_EMPLOYEE",
    "AGRIGATE_CHANNEL_PARTNER",
]);
export const Gender = z.enum(["MALE", "FEMALE", "OTHER"]);
export const UserType = z.enum(["INDIVIDUAL", "ORGANIZATION"]);
export const NotificationStatus = z.enum(["SCHEDULED", "SENT"]);
export const BalanceType = z.enum(["PO_ADVANCE", "FARMER_PAYOUT_ALLOCATION"]);
export const DiscountType = z.enum(["PERCENT", "FLAT"]);
export const NotificationTemplateType = z.enum(["HBS", "PSUB"]);
export const OrgCategory = z.enum([
    "SOLE_PROPRIETORSHIP",
    "PARTNERSHIP",
    "FPO",
    "COMPANY",
]);
export const ProfileTypeKey = z.enum([
    "channel-partner",
    "buyer",
    "seller",
    "output-supplier",
]);
export const KycDocVerificationStatus = z.enum([
    "VERIFIED",
    "PENDING",
    "UNSUPPORTED",
    "FAILED",
]);
export const EventInterestType = z.enum([
    "REGISTRATION",
    "ENQUIRY",
    "INTEREST",
]);
export const MSMERegistrationCategory = z.enum([
    "NONE",
    "MICRO",
    "SMALL",
    "MEDIUM",
]);
export const EventUserState = z.enum(["REGISTERED", "ENQUIRED", "NONE"]);
export const FeedItemType = z.enum([
    "Workshop/Meetings",
    "Broadcasts",
    "Posts",
    "Testimonials",
    "Schemes",
    "Survey",
]);
export const SurveyFormat = z.enum(["react-form-builder2", "custom"]);
export const SurveyUploadPurpose = z.enum([
    "QUESTION_BANNER",
    "OPTION_IMAGE",
    "SUBMISSION_ATTACHMENT",
]);
export const CoinSourceType = z.enum([
    "SURVEY",
    "TRANSACTION",
    "WORKSHOP",
    "FEED_USER_FEEDBACK",
]);
export const CoinRewardCategory = z.enum(["RECHARGE", "SEED", "INSURANCE"]);
export const RewardFulfillmentType = z.enum([
    "COUPON",
    "PHYSICAL",
    "XOXODAY_MARKETPLACE",
]);
export const XoxodayRedemptionStatus = z.enum([
    "PENDING",
    "COMPLETED",
    "PARTIALLY_REFUNDED",
    "REFUNDED",
]);
export const CoinTransactionEntity = z.enum([
    "SURVEY",
    "TRANSACTION",
    "WORKSHOP",
    "FEED_USER_FEEDBACK",
    "EXT_FEED_USER_FEEDBACK",
    "REWARD",
    "REWARD_REDEMPTION",
]);
export const CoinTransactionType = z.enum(["CREDIT", "DEBIT"]);
export const CoinRewardLocationThresholdType = z.enum(["GLOBAL", "CUSTOM"]);
/** @deprecated */
export const PayoutOption = z.enum(["CASH", "BANK_TRANSFER"]);
export const LeaderboardMode = z.enum(["GLOBAL", "CLUSTER"]);
export const AIChatRole = z.enum(["system", "user", "assistant"]);
export const ZohoSyncStatus = z.enum(["PENDING", "LINKED", "SKIPPED"]);
export const FeedItemSourceType = z.enum(["INTERNAL", "AUTO_SCRAPED"]);
export const FeedInteractionType = z.enum([
    "LIKE",
    "DISLIKE",
    "NOT_USEFUL",
    "SOMEWHAT_USEFUL",
    "VERY_USEFUL",
]);
export const PayableAdjustmentType = z.enum([
    "DEBIT_NOTE",
    "CREDIT_NOTE",
    "BUYER_TDS_DEDUCTION",
]);
export const InsurancePlanPremiumRecurrenceType = z.enum([
    "MONTHLY",
    "ANNUALLY",
    "NEVER",
]);
export const InsurancePlanStatus = z.enum(["ACTIVE", "INACTIVE"]);
export const InsurancePlanCategoryStatus = z.enum(["ACTIVE", "INACTIVE"]);
export const PricingVariationDirection = z.enum(["UPWARD", "DOWNWARD"]);
export const PaymentMode = z.enum(["CASH", "ONLINE"]);
export const PremiumLinkingMode = z.enum(["AUTOMATIC", "MANUAL"]);
export const PaymentLinkingMode = z.enum(["AUTOMATIC", "MANUAL"]);
export const RequestedEntityType = z.enum(["INSURANCE_APPLICATION"]);
export const RequestedAccessLevelType = z.enum([
    "DENIED",
    "VIEW",
    "MODIFY",
    "DELETE",
]);
export const ShipmentDeliveryMode = z.enum([
    "COMPANY_ARRANGED",
    "BUYER_ARRANGED",
    "CP_ARRANGED",
]);
export const ShipmentDocInvalidCode = z.enum([
    "BLURRY_IMAGE",
    "INCOMPLETE_OR_UNCLEAR",
    "REMAINDER_TO_UPLOAD",
    "WRONG_DOCUMENT",
]);
export const BookingStatus = z.enum([
    "REQUESTED",
    "PROPOSED",
    "CONFIRMED",
    "IN_PROGRESS",
    "COMPLETED",
    "PENDING_PAYMENT",
    "PENDING_CONFIRMATION",
    "CANCELLED",
    "REJECTED",
]);
export const MachinePurpose = z.enum(["RENT", "SELL"]);
export const MachinePurposes = MachinePurpose.array();
export const InsuranceApplicationApprovalStatus = z.enum([
    "PENDING",
    "APPROVED",
    "REJECTED",
]);
export const InputTransactionStatus = z.enum([
    "SUCCESS",
    "FAILED",
    "PENDING",
    "REFUND",
]);
export const DocumentCategory = z.enum(["CP_INVOICE"]);
export const InsuranceApplicationStatus = z.enum([
    "INCOMPLETE",
    "PENDING_APPROVAL",
    "REJECTED",
    "APPROVED",
    "EXPIRED",
]);
export const SoilTestingBookingStatus = z.enum([
    "PENDING",
    "CONFIRMED",
    "COMPLETE",
    "ABORTED",
]);
export const SoilTestingPaymentStatus = z.enum(["PENDING", "PAID", "REFUNDED"]);
export const IrrigationSourceType = z.enum([
    "RAINFED",
    "CANAL",
    "BOREWELL",
    "WATERSHED",
]);
export const AnimalHusbandaryType = z.enum([
    "COW",
    "BUFFALO",
    "GOAT",
    "FISHERY",
    "POULTRY",
]);
export const PayoutVendor = z.enum(["DECENTRO"]);
export const ResourceAccessRequestStatus = z.enum(["PENDING", "APPROVED"]);
//# sourceMappingURL=enums.js.map